import { render, staticRenderFns } from "./PlatDataPanelSelect.vue?vue&type=template&id=283e1c6c"
import script from "./PlatDataPanelSelect.vue?vue&type=script&lang=js"
export * from "./PlatDataPanelSelect.vue?vue&type=script&lang=js"
import style0 from "./PlatDataPanelSelect.vue?vue&type=style&index=0&id=283e1c6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports